import { render, staticRenderFns } from "./university-campaign-form.vue?vue&type=template&id=a7a24980&scoped=true&"
import script from "./university-campaign-form.vue?vue&type=script&lang=js&"
export * from "./university-campaign-form.vue?vue&type=script&lang=js&"
import style0 from "./university-campaign-form.vue?vue&type=style&index=0&id=a7a24980&scoped=true&lang=css&"
import style1 from "./university-campaign-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a24980",
  null
  
)

export default component.exports